import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 as uuid } from 'uuid';
import { NewTheme, Theme } from './types';
import { authActions } from '../auth/slice';

type ThemeState = Record<string, Theme>

const themeSlice = createSlice({
  name: 'themes',
  initialState: {} as ThemeState,
  reducers: {
    bulkDelete: (state, action: PayloadAction<string[]>) => {
      for (const themeID of action.payload) {
        delete state[themeID];
      }
    },
    bulkImport: (state, action) => {
      Object.assign(state, action.payload);
      delete state['_loaded'];
    },
    deleteTheme: (state, action: PayloadAction<Theme>) => {
      delete state[action.payload.id];
    },
    saveTheme: (state, action: PayloadAction<NewTheme>) => {
      if (!action.payload.id) {
        action.payload.id = uuid();
      }
      state[action.payload.id!] = action.payload as Theme;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(authActions.logOut, () => ({}));
  }
});

export const themeActions = themeSlice.actions;

export default themeSlice.reducer;
